/**
 * @file: 本地历史搜索记录Store
 *
 * @Author: PeiLing
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2019/03/29      2.0     PeiLing      Second version
 * 2023/01/05      3.0     FJJ          同步essaone平台逻辑迁移到此
 *
 * Copyright 2019, all rights reserved. Essa.cn
 * */
import store from 'store';
import NameSpace from "@store/nameSpace";

export default class LocalHistoryStore {
    constructor(options = {}) {
        this.MAX_STORAGE = options.max_storage || 500;         //最大存储量
        this.MAX_SHOWS = options.max_show || 5;                 //显示个数
        this.KEY = NameSpace.LOCAL_SEARCH_HISTORY;
    }

    /**
     * 添加历史搜索记录
     * 有条件set：需将最老的keyword（完全匹配）移除；限制最大存储量
     * @param keyword
     */
    set(keyword) {
        let list = this.getAll();
        //去重操作：移除最老的重复的keyword，添加新的keyword，以保证新的keyword显示在最前
        for (let i = 0, len = list.length; i < len; i++) {
            const item = list[i];
            if (item.trim().toLowerCase() === keyword.trim().toLowerCase()) {
                list.splice(i, 1);
                len--;
            }
        }
        list.unshift(keyword);
        //限制最大存储量
        if (list.length > this.MAX_STORAGE) {
            list = list.slice(0, this.MAX_STORAGE);
        }
        console.log("添加历史搜索记录 list 后",list)
        store.set(this.KEY, list);
        return list;
    }

    /**
     * 获取历史搜索记录，可指定个数
     * 无条件get：取出最新的N条历史搜索记录即可
     * @param keyword
     * @param length
     */
    get(keyword, length) {
        let list = this.getAll();
        if (!list || !list.length) return [];

        let data = [];
        length = length || this.MAX_SHOWS;

        //匹配关键字；无关键字，则取出最新的N条搜索历史记录
        if (keyword) {
            for (let i = 0, len = list.length; i < len; i++) {
                let item = list[i];
                if (!!~item.toLowerCase().indexOf(keyword.toLowerCase())) {
                    if (!data.length) {
                        data.push(item);
                    } else {
                        let state = false;
                        for (let j = 0, lenJ = data.length; j < lenJ; j++) {
                            if (item.toLowerCase() === data[j]) {
                                state = true;
                                break;
                            }
                        }
                        !state && data.push(item);
                    }
                }
                if (data.length === length) {
                    break;
                }
            }
        } else {
            data = list;
        }
        data = data.slice(0, length);
        return data;
    }

    /**
     * 获取全部历史搜索记录
     */
    getAll() {
        return store.get(this.KEY) || [];
    }

    /**
     * 清除全部历史搜索记录*/
    removeAll() {
        store.remove(this.KEY)
        return [];
    }
}
